var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232.7 233.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e0ba56;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2.17px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_5",
    "data-name": "Capa 5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.08,
    y: 126.8,
    width: 105.31,
    height: 105.31,
    rx: 10.43,
    ry: 10.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.31,
    y: 126.8,
    width: 105.31,
    height: 105.31,
    rx: 10.43,
    ry: 10.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.83,
    y: 1.08,
    width: 104.79,
    height: 104.79,
    rx: 10.38,
    ry: 10.38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "182.66 86.91 175.6 90.52 175.6 48.02 182.66 44.56 182.66 86.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.54,16.96c-1.43,2.09-2.88,4.19-4.37,6.3-1.2,1.71-2.39,3.39-3.59,5.06-.33-.82-.65-1.65-.98-2.47-1.62,1.06-3.26,2.11-4.92,3.16-17.83,11.17-35.8,19.66-53.31,26.09,1.26-.95,3.28-2.76,4.78-5.65.94-1.8,1.38-3.48,1.61-4.73,14.31-4.37,29.64-11.02,44.67-21.21,1.77-1.2,3.49-2.41,5.15-3.64-.32-.94-.63-1.89-.95-2.83,1.58.2,3.36.35,5.31.36,2.46.02,4.67-.17,6.58-.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.39 83.46 161.33 87.09 161.33 57.08 159.08 55.9 168.39 51.41 168.39 83.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "196.88 69.63 189.73 73.26 189.73 43.08 187.63 42 196.88 37.47 196.88 69.63"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.08,
    y: 1.08,
    width: 105.31,
    height: 105.31,
    rx: 10.43,
    ry: 10.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.18,37.16v32.34h11.54v-32.34h-11.54ZM74.14,66.52h-4.38v-26.26h4.38v26.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,37.16v32.34h11.54v-32.34h-11.54ZM37.96,66.52h-4.38v-26.26h4.38v26.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.93,34.77v37.25h13.92v-37.25h-13.92ZM56.23,69.49h-5.12v-32.34l5.12.06v32.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.97,84.9h-9.09s-56.31,0-56.31,0h-8.98c1.51-.66,3.47-1.68,5.5-3.28,1.92-1.51,3.31-3.06,4.28-4.31h17.49v2.49s19.93.02,19.93.02l.03-2.49h17.47c.95,1.24,2.32,2.79,4.22,4.3,2.02,1.6,3.97,2.62,5.47,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.17,28.3c0,3.51-3.05,6.26-6.42,6.26-2.97,0-5.29-2.3-6.02-4.97h-14.89s0-2.41,0-2.41h-19.95v2.4s-14.97-.02-14.97-.02c-.73,2.68-3.23,5-6.2,5-3.31,0-6.43-2.7-6.42-6.26,0-3.35,2.77-6.18,6.22-6.25h61.78c3.71-.25,6.86,2.7,6.87,6.25Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/Logo4.1cbd0cf401a2f3a075101afb79678c65.svg";
export { ForwardRef as ReactComponent };